import React from 'react';

import {
  Close,
} from '@mui/icons-material';
import {
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import Button from '../../../components/Button';
import ContentCard from '../../../components/ContentCard';
import ProfileIcon from '../../../components/ProfileIcon';
import StaffGroupChipsArray from '../../../components/StaffGroupChipsArray';
import UserDisabledStateChip from '../../../components/UserDisabledStateChip';
import { ShortStaff } from '../../../services/staff/types';

interface StaffDetailsProps {
  staff: ShortStaff;
  onClose: () => void;
}

const StaffDetails = ({
  staff,
  onClose = () => {},
}: StaffDetailsProps) => {
  const theme = useTheme();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
        >
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
          <Typography variant="h5">
            Staff Details
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <ContentCard>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                spacing={2}
              >
                <ProfileIcon
                  size={72}
                  firstName={staff.firstName}
                  lastName={staff.lastName}
                  imageUrl={staff.profileIcon?.image}
                  color={staff.profileIcon?.color}
                />
                <Stack
                  direction="column"
                >
                  <Typography variant="h4" color={theme.palette.darkPrimary.main}>
                    {staff.firstName}
                  </Typography>
                  <Typography variant="h4" color={theme.palette.darkPrimary.main}>
                    {staff.lastName}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction="row"
                alignItems="center"
                // Use gap instead of spacing to allow for vertical gap in the event of a wrap
                gap={1}
                flexWrap="wrap"
                display="flex"
                width="100%"
              >
                <StaffGroupChipsArray groups={staff.groups} limit={8} />
                <UserDisabledStateChip disabled={staff.disabled} />
              </Stack>
            </Grid>
          </Grid>
        </ContentCard>
      </Grid>
      <Grid item xs={12}>
        <ContentCard variant="outlined">
          <Stack
            direction="column"
            spacing={1}
          >
            <Typography variant="subtitle2">
              Email
            </Typography>
            <Typography variant="body1">
              {staff.email}
            </Typography>
            <Typography variant="subtitle2">
              Phone Number
            </Typography>
            <Typography variant="body1">
              {staff.phoneNumber}
            </Typography>
          </Stack>
        </ContentCard>
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" justifyContent="right">
          <Button href={`/admin/staff/${staff.id}`}>
            Details
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default StaffDetails;
